import { Contact } from 'contact/contact';
import { ContactOutput } from 'contact/model/contact.output';

export abstract class ContactConverterPort {
	public abstract contactAsEntity(output: ContactOutput): Contact;

	public abstract contactsAsEntities(outputs: ContactOutput[]): Contact[];
}
